import React from "react";
import styles from "./loader.module.css";

const Loader: React.FC = () => (
  <div className={styles.loaderWrapper}>
    <div className={styles.spinner}></div>
  </div>
);

export default Loader;